// ECOPD-5414 / ECOPD-5476 — adjustment tags shown on the Campaign Dashboard.
// Values MUST equal the wire codes: 4 codes come from the BE on each
// CampaignDashboardRecord.adjustmentTags; the 3 pacing codes are appended
// client-side in CampaignDashboardModel (see getCampaignData).
export enum AdjustmentTagType {
  // BE-provided
  NO_CREATIVE_BOUND = 'NO_CREATIVE_BOUND',
  CREATIVE_REJECTED = 'CREATIVE_REJECTED',
  NOT_DELIVERING = 'NOT_DELIVERING',
  STORE_BANNED = 'STORE_BANNED',
  // Client-side pacing tags
  BEHIND_SCHEDULE = 'BEHIND_SCHEDULE',
  SEVERELY_BEHIND = 'SEVERELY_BEHIND',
  BUDGET_UNDERSPEND_RISK = 'BUDGET_UNDERSPEND_RISK'
}

// Colour groups map to the DS variables in colors.scss:
//   deepWarning -> $deep-warning (#ee75ee)
//   warning     -> $warning      (#ffa953)
//   danger      -> $danger       (#ce555c)
export type AdjustmentTagColorGroup = 'deepWarning' | 'warning' | 'danger';

export const adjustmentTagColorGroup: Record<
  AdjustmentTagType,
  AdjustmentTagColorGroup
> = {
  [AdjustmentTagType.NOT_DELIVERING]: 'deepWarning',
  [AdjustmentTagType.SEVERELY_BEHIND]: 'deepWarning',
  [AdjustmentTagType.BUDGET_UNDERSPEND_RISK]: 'deepWarning',
  [AdjustmentTagType.BEHIND_SCHEDULE]: 'warning',
  [AdjustmentTagType.STORE_BANNED]: 'warning',
  [AdjustmentTagType.NO_CREATIVE_BOUND]: 'danger',
  [AdjustmentTagType.CREATIVE_REJECTED]: 'danger'
};

// Stable render/filter order (multiple capsules allowed; BE contract states "no
// ordering", so this is purely a deterministic option list for the filter).
export const allAdjustmentTagTypes: AdjustmentTagType[] = [
  AdjustmentTagType.NO_CREATIVE_BOUND,
  AdjustmentTagType.CREATIVE_REJECTED,
  AdjustmentTagType.NOT_DELIVERING,
  AdjustmentTagType.BEHIND_SCHEDULE,
  AdjustmentTagType.SEVERELY_BEHIND,
  AdjustmentTagType.STORE_BANNED,
  AdjustmentTagType.BUDGET_UNDERSPEND_RISK
];
